import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import { Input, Select, Textarea } from '../../../../components/base/index';
import { Link } from 'react-router-dom';

export default function KodeMatpelTable(props) {
  const { onFormChange, form } = props;
  return (
    <div className="daftar-ekskul__content">
                <div className="daftar-ekskul__header">
                  

                </div>
                <div className="daftar-ekskul__body">
                  <table className="daftar-ekskul__table">
                    <thead>
                      <tr>
                        <th>Mata Pelajaran</th>
                        <th>Kelas 1</th>
                        <th>Kelas 2</th>
                        <th>Kelas 3</th>
                        <th>Kelas 4</th>
                        <th>Kelas 5</th>
                        <th>Kelas 6</th>
                      </tr>
                    </thead>
                    <tbody>
                      {/* {
                      map(journal.details, (list, idx) => (
                        <tr key={`journal_detail_${idx}`}>
                          <td>{idx + 1}</td>
                          <td>{list.code_of_account}</td>
                          <td>{list.parameter_code.title}</td>
                          <td>{list.description}</td>
                          <td className="nominal">{commaFormatted(list.amount)}</td>
                        </tr>
                      ))
                    } */}
                    <tr>
                        <td>Bahasa Indonesia</td>
                        <td><Link to={'/dashboard/kurikulum/mata-pelajaran/edit-kode-mata-pelajaran'}>BINDO</Link> 
                        </td>
                        <td>Ulangan/Quiz blablablaa</td>
                        <td>Tanggal </td>
                        <td>-</td>
                        <td></td>
                        <td></td>
                       

                    </tr>
                   
                    </tbody>
                    {/* <tfoot>
                      <tr>
                        <td colSpan="1" className="nominal">Catatan Wali Kelas</td>
                        <td colSpan="8" className="nominal"></td>
                      </tr>
                    </tfoot> */}
                  </table>
                </div>
              </div>
  );
}
KodeMatpelTable.propTypes = {
  onFormChange: PropTypes.func,
  form: PropTypes.object.isRequired,
};
KodeMatpelTable.defaultProps = {
  onFormChange: noop,
};
